import ApiBuilder, { } from "@/api/ApiBuilder";
import { CreateOrderPaymentType,ManulBookingPayload,createRecommendationType, verifyPayment,rescheduleBookingType } from "@/types/interfaceType";
import { createAsyncThunk, isRejectedWithValue } from "@reduxjs/toolkit";

interface CreatePaymentOrderArgs {
    payload: CreateOrderPaymentType;
    callback?: (response: any) => void; // Optional callback
}
interface CreatePaymentOrderForRecommandationArgs {
    payload: createRecommendationType;
    callback?: (response: any) => void; // Optional callback
}
interface getdefaultArgs {
    pathparams?: String;
    token?: string;
    callback?: (response: any) => void; // Optional callback
}

interface RescheduleBookingArg{
      pathparams?: string;
      data:rescheduleBookingType,
    callback?: (response: any) => void; // Optiona
}

interface createBookings{
    

    payload: ManulBookingPayload,
    callback?: (response: any) => void; // Optional callback
}



interface cancelBookings{
    payload?: {bookingId:string},
    pathparams?: string;
    callback?: (response: any) => void; // Optional callback
}


interface VerifyPaymentArgs {
    payload: verifyPayment;
    callback?: (response: any) => void; // Optional callback
}

export const createPaymentOrder = createAsyncThunk<any, CreatePaymentOrderArgs>(
    "payment/createPaymentOrder",
    async ({ payload, callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.createPaymentOrder(payload);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Payment order creation failed";

            return rejectWithValue(errorMessage);
        }
    }
);

export const verifyOnboardingPayment = createAsyncThunk<any, VerifyPaymentArgs>(
    "payment/verifyOnboardingPayment",
    async ({ payload, callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.verifyOnboardingPayment(payload);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Payment verification failed";

            return rejectWithValue(errorMessage);
        }
    }
);


export const createPaymentOrderForDirectBookingLinkSubscription = createAsyncThunk<any, CreatePaymentOrderArgs>(
    "payment/createPaymentOrderForDirectBookingLinkSubscription",
    async ({ payload, callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.createPaymentOrderForDirectBookingLinkSubscription(payload);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Payment order creation failed";
                if (callback) {
                    callback(error || {error:"Payment order creation failed",success:false})
                }
            return rejectWithValue(errorMessage);
        }
    }
);

export const verifyDirectBookingLinkSubscriptionPayment = createAsyncThunk<any, VerifyPaymentArgs>(
    "payment/verifyDirectBookingLinkSubscriptionPayment",
    async ({ payload, callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.verifyDirectBookingLinkSubscriptionPayment(payload);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Payment verification failed";

            return rejectWithValue(errorMessage);
        }
    }
);

export const getVendorDirectBookingLinkVenuesSubscription = createAsyncThunk<any, getdefaultArgs>(
    "payment/getVendorDirectBookingLinkVenuesSubscription",
    async ({callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.getVendorDirectBookingLinkVenuesSubscription();
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Venue Fetch failed";

            return rejectWithValue(errorMessage);
        }
    }
);


export const getSubscriptionPlanDetails = createAsyncThunk<any, getdefaultArgs>(
    "payment/getSubscriptionPlanDetails",
    async ({callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.getSubscriptionPlanDetails();
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Something went wrong";

            return rejectWithValue(errorMessage);
        }
    }
);




export const createRecommendation = createAsyncThunk<any, CreatePaymentOrderForRecommandationArgs>(
    "payment/vendor/createRecommendation",
    async ({ payload, callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.createRecommendation(payload);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Payment order creation failed";
                if (callback) {
                    callback(error || {error:"Payment order creation failed",success:false})
                }
            return rejectWithValue(errorMessage);
        }
    }
);


export const verifyRecommendationSubscriptionPayment = createAsyncThunk<any, VerifyPaymentArgs>(
    "payment/verifyRecommendationSubscriptionPayment",
    async ({ payload, callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.verifyRecommendationSubscriptionPayment(payload);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Payment verification failed";

            return rejectWithValue(errorMessage);
        }
    }
);


export const createManualBooking = createAsyncThunk<any, createBookings>(
    "payment/createManualBooking",
    async ({ payload, callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.createManualBooking(payload);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Fetch Failed ";

            return rejectWithValue(errorMessage);
        }
    }
);

/**
 * Direct booking — no payment link. The customer pays the vendor directly, so
 * the booking comes back already confirmed rather than pending payment.
 */
export const createDirectBooking = createAsyncThunk<any, createBookings>(
    "payment/createDirectBooking",
    async ({ payload, callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.createDirectBooking(payload);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Fetch Failed ";

            return rejectWithValue(errorMessage);
        }
    }
);

export const cancelManualBooking = createAsyncThunk<any, cancelBookings>(
    "payment/cancelManualBooking",
    async ({ pathparams, callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.cancelManualBooking(pathparams);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Fetch Failed ";

            return rejectWithValue(errorMessage);
        }
    }
);


export const rescheduleBooking = createAsyncThunk<any, RescheduleBookingArg>(
    "booking/rescheduleBooking",
    async ({ data , callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.rescheduleBooking(data);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            if (callback) {
                callback(error)
            }
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Reschedule failed";
            return rejectWithValue(errorMessage);
        }
    }
);
